import { useTeam } from "@repo/api";
import { type Settings, useSettings } from "@repo/ui";
import { addDays, differenceInDays, startOfDay } from "date-fns";

import {
  isScheduleBlocksEnabled,
  isUploadScheduleEnabled,
} from "../utils/utils";

const isScheduleVisible = (
  calendar: Settings["calendar"],
  selectedDate: Date
) => {
  if (calendar?.schedule_visibility_limit === undefined) {
    return true;
  }

  const visibilityLimitDays = Number(calendar.schedule_visibility_limit);

  if (Number.isNaN(visibilityLimitDays)) {
    // If the configuration value is invalid, default to showing schedules.
    return true;
  }

  return (
    differenceInDays(
      addDays(startOfDay(new Date()), visibilityLimitDays),
      startOfDay(selectedDate)
    ) > 0
  );
};

export const useIsScheduleEnabled = (selectedDate: Date, teamId?: number) => {
  const { calendar } = useSettings();
  const { data: team } = useTeam(teamId);

  return (
    isScheduleVisible(calendar, selectedDate) &&
    (isUploadScheduleEnabled(calendar, team?.buCode) ||
      isScheduleBlocksEnabled(calendar, team?.buCode))
  );
};
